import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { verifyUser } from '../../-global-state/actions/user-actions';
import './log-in.css'

class LogIn extends Component {
    constructor(){
        super();
        this.state = {
            logInUserName: '',
            logInPassword: '',
            userLogIn: {}
        }
    }

    displayLogInForm = () => {
        return (
            <form className="my-form border border-dark p-5" onSubmit={this.handleLogInSubmit}>
                <h1 className="text-white display-4 text-center mb-5">Log In</h1>
                <div className="form-group">
                    <input type="text" className="form-control bg-dark text-white text-center mb-3" id="logInUserName" placeholder="Username" maxLength="75" required 
                        value={this.state.logInUserName} 
                        onChange={e => this.setState({ logInUserName: e.target.value })}
                    />
                    <input type="password" className="form-control mt-1 bg-dark text-white text-center mb-5" id="logInPassword" placeholder="Password" maxLength="75" required 
                        value={this.state.logInPassword} 
                        onChange={e => this.setState({ logInPassword: e.target.value })}
                    />
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-success btn-lg submit-button">Submit</button>
                </div>
            </form>
        )
    }

    render() {
        if(this.props.userLoggedIn === true){
            return <Redirect to="/" />
        } else {
            return(
                <div id="login" className="d-flex align-items-center justify-content-center">
                    <div className="container fade-in-fwd">
                        <div className="row">
                            <div className="col-12 p-5">
                                {this.displayLogInForm()}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    handleLogInSubmit = e => {
        e.preventDefault();
        this.setState({ userLogIn: {
            userName: this.state.logInUserName,
            password: this.state.logInPassword
        }}, () => {
            fetch(process.env.REACT_APP_USER_LOGIN, {
                method: 'post',
                mode: 'cors',
                body: JSON.stringify(this.state.userLogIn),
                headers: {
                    "Content-type" : "application/json"
                }
            }).then(response => response.json()).then(json => {
                if(json.success){
                    localStorage.setItem("token", json.data._id);
                    this.props.verifyUser(localStorage.getItem("token"));
                }
                alert(json.message);
                this.setState({
                    signInUserName: '',
                    signInPassword: '',
                    userSignIn: {}
                })
                if(json.success === true){
                    window.location.replace('/');
                }
            })
        })
    }

}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.userState.userLoggedIn,
    }
}

export default connect(mapStateToProps, { verifyUser })(LogIn);